import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

export default function CookieBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookies_consent");
    if (!consent) {
      // Small delay to avoid flash on page load
      const timer = setTimeout(() => setShowBanner(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookies_consent", JSON.stringify({
      necessary: true,
      analytics: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const rejectAll = () => {
    localStorage.setItem("cookies_consent", JSON.stringify({
      necessary: true,
      analytics: false,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div 
      className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fadeInUp"
      data-testid="cookie-banner"
    >
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-2xl border border-slate-200 p-6">
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 bg-[#22c55e]/10 rounded-full flex items-center justify-center shrink-0">
            <Cookie className="text-[#22c55e]" size={24} />
          </div>
          
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-slate-900 mb-2">
              Este sitio web utiliza cookies
            </h3>
            <p className="text-slate-600 text-sm mb-4">
              Utilizamos cookies propias y de terceros para analizar el uso del sitio web y mejorar su experiencia de navegación. 
              Puede aceptar todas las cookies, rechazarlas o configurar sus preferencias.
              Más información en nuestra{" "}
              <Link to="/politica-cookies" className="text-[#22c55e] hover:underline">
                Política de Cookies
              </Link>{" "}
              y{" "}
              <Link to="/politica-privacidad" className="text-[#22c55e] hover:underline">
                Política de Privacidad
              </Link>.
            </p>
            
            <div className="flex flex-wrap gap-3">
              <button
                onClick={acceptAll}
                className="bg-[#22c55e] hover:bg-[#16a34a] text-white px-6 py-2.5 rounded-full text-sm font-medium transition-colors"
                data-testid="accept-cookies"
              >
                Aceptar todas
              </button>
              <button
                onClick={rejectAll}
                className="bg-slate-100 hover:bg-slate-200 text-slate-700 px-6 py-2.5 rounded-full text-sm font-medium transition-colors"
                data-testid="reject-cookies"
              >
                Rechazar
              </button>
              <Link
                to="/politica-cookies"
                className="bg-transparent border border-slate-300 hover:bg-slate-50 text-slate-700 px-6 py-2.5 rounded-full text-sm font-medium transition-colors"
              >
                Configurar
              </Link>
            </div>
          </div>

          <button
            onClick={rejectAll}
            className="p-2 hover:bg-slate-100 rounded-full transition-colors shrink-0"
            aria-label="Cerrar"
          >
            <X size={20} className="text-slate-400" />
          </button>
        </div>
      </div>
    </div>
  );
}
